<template>
    <TopSliderComponent />
    <BenefitsComponent />
    <WhatSaidComponent />
</template>

<script>  
// Imports VUE
import TopSliderComponent from '../components/home/top_slider.vue';
import BenefitsComponent from '../components/home/benefits.vue';
import WhatSaidComponent from '../components/home/what_said.vue';

export default {  
  name: "App",
  components: {
      TopSliderComponent,
      BenefitsComponent,
      WhatSaidComponent
  },
  mounted() {  
    document.title = "Covalent - Nunca IoT estuvo tan a tu alcance";  
  },  
};  
</script>